import { $ } from 'ng'

export default () => ({
    restrict: 'A',
    link(scope, element, attrs) {
        let widget = null;
        if (attrs.jqueryPluginArguments) {
            const args = scope.$eval(attrs.jqueryPluginArguments);
            widget = element[attrs.jqueryPlugin].apply(this, args);
        } else if (attrs.jqueryPluginOptions) {
            const options = scope.$eval(attrs.jqueryPluginOptions);
            widget = element[attrs.jqueryPlugin](options);
        } else {
            widget = element[attrs.jqueryPlugin]();
        }
        if (attrs.jqueryPluginScope) {
            scope[attrs.jqueryPluginScope] = widget;
        }
    }
});

export const jqPlugIn = ($window) => ({
    link(scope, element, attr) {
        $(document).ready(function () {
            const $el = $(element);
            const method = attr.jqPlugIn;
            delete attr.jqPlugIn;
            console.info(method, attr, $el);
            $el[method] && $el[method](attr);
        });
    }
});
